import { SKU } from '../models/sku'

import * as skus from '../actions/skus.actions'

export interface State {
    loading: boolean
    SKUs: SKU[]
    error: any
}

const initialState: State = {
    loading: false,
    SKUs: [],
    error: null
}

export function reducer(
    state = initialState,
    action: skus.Actions
) {
    switch (action.type) {
        case skus.GET:
            return {
                ...state,
                loading: true
            }

        case skus.GET_SUCCESS:
            return {
                ...state,
                loading: false,
                SKUs: action.payload
            }

        case skus.GET_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            }

        default: 
            return state
    }
}

export const isLoading = (state: State) => state.loading
export const getSKUs = (state: State) => state.SKUs
export const getError = (state: State) => state.error
